import { render, staticRenderFns } from "./ContentCardBase.vue?vue&type=template&id=ca0cd1ec&"
import script from "./ContentCardBase.vue?vue&type=script&lang=js&"
export * from "./ContentCardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports